
import React from 'react';
import { AlertCircle } from 'lucide-react';
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import { Button } from '@/components/ui/button';

interface BreathingErrorProps {
  errorMessage: string;
  onRetry: () => void;
}

const BreathingError: React.FC<BreathingErrorProps> = ({ errorMessage, onRetry }) => {
  return (
    <div 
      className="w-full h-full flex flex-col items-center justify-center p-6"
      role="alert"
      aria-live="assertive"
    >
      <Alert variant="destructive" className="max-w-md mb-4">
        <AlertCircle className="h-4 w-4" />
        <AlertTitle>Breathing Exercise Error</AlertTitle>
        <AlertDescription>{errorMessage}</AlertDescription>
      </Alert>
      <p className="text-gray-600 mb-4 text-center">
        We encountered an issue with the breathing exercise. Please try again.
      </p>
      <Button 
        onClick={onRetry} 
        className="mt-4"
        aria-label="Retry breathing exercise"
      >
        Restart Exercise
      </Button>
    </div>
  );
};

export default BreathingError;
